import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import closeOutService from "./closeOutService";
type closeoutProps = {
  isLoading: boolean;
  isfileUpload: boolean;
  files: any[];
  errorMessage: any;
  exceededFiles: any[];
  isUploading: boolean;
  displayProgress: boolean;
  uploadedFiles: any[];
  uploadedFilesSuccess: any[];
  preuploadedFilesSuccess: any[];
  uploadProgress: any;
  constructedFiles: any[];
  isFilesAdded: boolean;
  setEnable: boolean;
  confidentialChecked: boolean;
  restrictedChecked: boolean;
  internalChecked: boolean;
  confidentialSelection: any;
  restrictedSelection: any;
  internalSelection: any;
  fileClassificationSelection: any;
  historicalFormData: any;
  historicalPending: boolean;
  historicalError: boolean;
  autofillData: any;
};
const initialState: closeoutProps = {
  isLoading: false,
  isfileUpload: false,
  files: [],
  errorMessage: null,
  exceededFiles: [],
  isUploading: false,
  displayProgress: false,
  uploadedFiles: [],
  uploadedFilesSuccess: [],
  uploadProgress: {},
  preuploadedFilesSuccess: [],
  constructedFiles: [],
  isFilesAdded: false,
  setEnable: false,
  confidentialChecked: false,
  restrictedChecked: false,
  internalChecked: false,
  confidentialSelection: {},
  restrictedSelection: {},
  internalSelection: {},
  fileClassificationSelection: {},
  historicalFormData: {},
  historicalPending: false,
  historicalError: false,
  autofillData: {} as Record<string, any>,
};
const closeOutSlice = createSlice({
  name: "closeOutSlice",
  initialState,
  reducers: {
    setisfilUpload(state, action) {
      state.isfileUpload = action.payload;
    },
    addFiles(state, action) {
      state.files = [...state.files, ...action.payload];
    },
    setisfileAdded(state, action) {
      state.isFilesAdded = action.payload;
    },
    handleremoveFile(state, action) {
      state.confidentialSelection = {
        ...state.confidentialSelection,
        [action.payload]: undefined,
      };
      state.restrictedSelection = {
        ...state.restrictedSelection,
        [action.payload]: undefined,
      };
      state.internalSelection = {
        ...state.internalSelection,
        [action.payload]: undefined,
      };
      state.files = state.files.filter((file) => file.name !== action.payload);
    },
    setConfidentialChecked(state, action) {
      state.confidentialChecked = action.payload;
    },
    setRestrictedChecked(state, action) {
      state.restrictedChecked = action.payload;
    },
    setInternalChecked(state, action) {
      state.internalChecked = action.payload;
    },
    setFileClassification(state, action) {
      state.fileClassificationSelection = action.payload;
    },
    setErrorMessage(state, action) {
      state.errorMessage = action.payload;
    },
    setUploadProgress(state, action) {
      state.uploadProgress = {
        ...state.uploadProgress,
        [action.payload.fileName]: action.payload.progress,
      };
    },
    setexceededFiles(state, action) {
      state.errorMessage = action.payload;
    },
    setConstructedFiles(state, action) {
      state.constructedFiles = action.payload;
    },
    setIsuploading(state, action) {
      state.isUploading = action.payload;
    },
    setDisplayProgress(state, action) {
      state.displayProgress = action.payload;
    },
    setUploadingPrgress() {},
    setUploadedfileSuccess(state, action) {
      state.uploadedFilesSuccess = [
        ...state.uploadedFilesSuccess,
        ...action.payload.filter(
          (file: string) => !state.uploadedFilesSuccess.includes(file)
        ),
      ];
    },
    setPreUploadedfileSuccess(state, action) {
      state.preuploadedFilesSuccess = [
        ...state.preuploadedFilesSuccess,
        ...action.payload.filter(
          (file: string) => !state.preuploadedFilesSuccess.includes(file)
        ),
      ];
    },
    setUploadedFiles(state, action) {
      state.uploadedFiles = action.payload;
    },
    confidentialRadioChange(state, action) {
      const { value, fileName } = action.payload;
      state.confidentialSelection = {
        ...state.confidentialSelection,
        [fileName]: value,
      };
      if (value === "yes") {
        state.restrictedSelection = {
          ...state.restrictedSelection,
          [fileName]: undefined,
        };
        state.internalSelection = {
          ...state.internalSelection,
          [fileName]: undefined,
        };
        state.autofillData = {
          ...state.autofillData,
          [fileName]: state.autofillData[fileName] === true ? true : false,
        };
      }

      const allConfidentialSelected = state.files.every(
        (file: any) =>
          state.confidentialSelection[file.name] === "yes" ||
          file.name === fileName
      );
      state.confidentialChecked = allConfidentialSelected;
    },
    restrictedRadioChange(state, action) {
      const { value, fileName } = action.payload;
      state.restrictedSelection = {
        ...state.restrictedSelection,
        [fileName]: value,
      };
      if (value === "yes") {
        state.confidentialSelection = {
          ...state.confidentialSelection,
          [fileName]: undefined,
        };
        state.internalSelection = {
          ...state.internalSelection,
          [fileName]: undefined,
        };
        state.autofillData = {
          ...state.autofillData,
          [fileName]: false,
        };
      }

      const allrestrictionSelected = state.files.every(
        (file: any) =>
          state.restrictedSelection[file.name] === "yes" ||
          file.name === fileName
      );
      state.restrictedChecked = allrestrictionSelected;
    },
    internalRadioChange(state, action) {
      const { value, fileName } = action.payload;
      state.internalSelection = {
        ...state.internalSelection,
        [fileName]: value,
      };
      if (value === "yes") {
        state.confidentialSelection = {
          ...state.confidentialSelection,
          [fileName]: undefined,
        };
        state.restrictedSelection = {
          ...state.restrictedSelection,
          [fileName]: undefined,
        };
        state.autofillData = {
          ...state.autofillData,
          [fileName]: state.autofillData[fileName] === true ? true : false,
        };
      }
      const allinternalSelected = state.files.every(
        (file: any) =>
          state.internalSelection[file.name] === "yes" || file.name === fileName
      );
      state.internalChecked = allinternalSelected;
    },
    confidentialCheckBoxChange(state, action) {
      state.confidentialChecked = action.payload;
      const updatedConfidentialSelection: any = {};
      const updatedinternalSelection: any = {};
      const updatedRestrictedSelection: any = {};
      const autoFillData: any = {};
      state.files.forEach((file: any) => {
        updatedConfidentialSelection[file.name] =
          (action.payload && !state.uploadedFilesSuccess.includes(file.name)) ||
          (state.confidentialSelection[file.name] === "yes" &&
            state.uploadedFilesSuccess.includes(file.name))
            ? "yes"
            : undefined;
        autoFillData[file.name] =
          state.autofillData[file.name] === true && action.payload
            ? true
            : false;
        updatedinternalSelection[file.name] =
          state.internalSelection[file.name] &&
          state.uploadedFilesSuccess.includes(file.name)
            ? "yes"
            : undefined;
        updatedRestrictedSelection[file.name] =
          state.restrictedSelection[file.name] &&
          state.uploadedFilesSuccess.includes(file.name)
            ? "yes"
            : undefined;
      });
      state.confidentialSelection = updatedConfidentialSelection;
      state.autofillData = autoFillData;
      if (action.payload) {
        state.restrictedChecked = false;
        state.restrictedSelection = updatedRestrictedSelection;
        state.internalChecked = false;
        state.internalSelection = updatedinternalSelection;
      }
    },
    restrictedCheckBoxChange(state, action) {
      state.restrictedChecked = action.payload;
      const updatedRestrictedSelection: any = {};
      const autoFillData: any = {};
      const updatedinternalSelection: any = {};
      const updatedConfidentialSelection: any = {};
      state.files.forEach((file: any) => {
        updatedRestrictedSelection[file.name] =
          (action.payload && !state.uploadedFilesSuccess.includes(file.name)) ||
          (state.restrictedSelection[file.name] &&
            state.uploadedFilesSuccess.includes(file.name))
            ? "yes"
            : undefined;
        autoFillData[file.name] = false;
        updatedinternalSelection[file.name] =
          state.internalSelection[file.name] &&
          state.uploadedFilesSuccess.includes(file.name)
            ? "yes"
            : undefined;
        updatedConfidentialSelection[file.name] =
          state.confidentialSelection[file.name] &&
          state.uploadedFilesSuccess.includes(file.name)
            ? "yes"
            : undefined;
      });
      state.restrictedSelection = updatedRestrictedSelection;
      state.autofillData = autoFillData;
      // Disable Confidential radio buttons when Restricted checkbox is selected
      if (action.payload) {
        state.internalChecked = false;
        state.internalSelection = updatedinternalSelection;
        state.confidentialChecked = false;
        state.confidentialSelection = updatedConfidentialSelection;
      }
    },
    internalCheckBoxChange(state, action) {
      state.internalChecked = action.payload;
      const updatedInternalSelection: any = {};
      const updatedRestrictedSelection: any = {};
      const updatedConfidentialSelection: any = {};
      const autoFillData: any = {};
      state.files.forEach((file: any) => {
        updatedInternalSelection[file.name] =
          (action.payload && !state.uploadedFilesSuccess.includes(file.name)) ||
          (state.internalSelection[file.name] &&
            state.uploadedFilesSuccess.includes(file.name))
            ? "yes"
            : undefined;
        autoFillData[file.name] =
          state.autofillData[file.name] === true && action.payload
            ? true
            : false;
        updatedConfidentialSelection[file.name] =
          state.confidentialSelection[file.name] &&
          state.uploadedFilesSuccess.includes(file.name)
            ? "yes"
            : undefined;
        updatedRestrictedSelection[file.name] =
          state.restrictedSelection[file.name] &&
          state.uploadedFilesSuccess.includes(file.name)
            ? "yes"
            : undefined;
      });
      state.autofillData = autoFillData;
      state.internalSelection = updatedInternalSelection;
      if (action.payload) {
        state.confidentialChecked = false;
        state.confidentialSelection = updatedConfidentialSelection;
        state.restrictedChecked = false;
        state.restrictedSelection = updatedRestrictedSelection;
      }
    },
    resetAll(state) {
      state.isLoading = false;
      state.isfileUpload = false;
      state.files = [];
      state.errorMessage = null;
      state.exceededFiles = [];
      state.isUploading = false;
      state.displayProgress = false;
      state.uploadedFiles = [];
      state.uploadedFilesSuccess = [];
      state.uploadProgress = {};
      state.constructedFiles = [];
      state.isFilesAdded = false;
      state.setEnable = false;
      state.confidentialChecked = false;
      state.restrictedChecked = false;
      state.internalChecked = false;
      state.confidentialSelection = {};
      state.restrictedSelection = {};
      state.internalSelection = {};
      state.fileClassificationSelection = {};
      state.autofillData = {};
    },
    setPreUploadedFilesToIntake(state) {
      const uploadedFileNames = state.preuploadedFilesSuccess.map(
        (file) => file.file_name
      );
      state.uploadedFilesSuccess = uploadedFileNames;
    },
    resetPreUpload(state) {
      state.preuploadedFilesSuccess = [];
    },
    setIntakeData(state, action) {
      state.historicalFormData = action.payload;
    },
    setAutofillData(state, action) {
      const { value, fileName } = action.payload;
      state.autofillData = Object.fromEntries(
        Object.keys(state.autofillData).map((key) => {
          if (value) {
            return [
              key,
              key === fileName ||
              (state.autofillData[key] === true &&
                state.uploadedFilesSuccess.includes(key))
                ? true
                : false,
            ];
          } else if (!value) {
            return [
              key,
              state.autofillData[key] === true &&
              state.uploadedFilesSuccess.includes(key)
                ? true
                : false,
            ];
          }
          return [key, false];
        })
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(saveIntakeFiles.pending, (state) => {
        state.historicalPending = true;
        state.historicalError = false;
      })
      .addCase(saveIntakeFiles.fulfilled, (state, action) => {
        state.historicalFormData = action.payload;
        state.historicalPending = false;
        state.historicalError = false;
      })
      .addCase(saveIntakeFiles.rejected, (state) => {
        state.historicalPending = false;
        state.historicalError = true;
      });
  },
});
export const saveIntakeFiles = createAsyncThunk<any, any>(
  "closeOutSlice/saveIntakeFiles",
  async (apiParam, thunkAPI) => {
    try {
      const response = await closeOutService.getPrefilledData(apiParam);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const CloseOutActions = closeOutSlice.actions;
export default closeOutSlice.reducer;
